module.exports = __webpack_public_path__ + "img/Lavender.d306eeab.jpg";